export default __webpack_public_path__ + "static/media/go2016B.ac644a27.png";